import { RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { MAX_LABEL_LENGTH } from './nodeChartLabels';

/**
 * Поле переименования. Сохраняет по уходу с поля и по Enter, Escape возвращает сохранённое.
 * Пустое поле — подпись по умолчанию, она же плейсхолдер.
 *
 * Общее для карточки графиков пакета нод и вкладки «Интерфейс»: поведение у них одинаковое,
 * а различаются только источник умолчания и эндпоинт записи.
 */
const LabelField = ({
  id,
  trackId,
  value,
  placeholder,
  pending,
  renamed,
  ariaLabel,
  resetTitle = 'Вернуть название по умолчанию',
  onChange,
  onCommit,
  onRevert,
  onReset
}) => (
  <div className="flex min-w-0 items-center gap-1">
    <Input
      id={id}
      data-ev={trackId}
      className="h-8"
      value={value}
      placeholder={placeholder}
      maxLength={MAX_LABEL_LENGTH}
      disabled={pending}
      aria-label={ariaLabel}
      onChange={(event) => onChange(event.target.value)}
      onBlur={onCommit}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.currentTarget.blur();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          onRevert();
        }
      }}
    />
    {renamed && (
      <Button
        type="button"
        data-ev="settings.label_field.reset"
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0"
        title={resetTitle}
        aria-label={resetTitle}
        disabled={pending}
        onClick={onReset}
      >
        <RotateCcw className="h-4 w-4" />
      </Button>
    )}
  </div>
);

export default LabelField;
